import component from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-contact/lni-child-labor-complaint-contact.component.vue';
import module from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-contact/lni-child-labor-complaint-contact.module.js';

export default {
    component,
    module,
};